var _path, _path2, _path3, _path4, _clipPath, _filter, _clipPath2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0F6FE",
    style: {
      fill: "#F0F6FE",
      fill: "color(display-p3 0.9412 0.9647 0.9961)",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.4056C17 20.1548 18.1353 19.2108 19.3652 19.4392L27 20.8571V45L18.6348 43.4465C17.6873 43.2705 17 42.4438 17 41.4801V21.4056Z",
    fill: "url(#paint0_linear_6764_129072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 19L45.3652 20.5535C46.3127 20.7295 47 21.5562 47 22.5199V42.5944C47 43.8452 45.8647 44.7892 44.6348 44.5608L37 43.1429V19Z",
    fill: "url(#paint1_linear_6764_129072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 19L27 20.8571V45L37 43.1429V19Z",
    fill: "url(#paint2_linear_6764_129072)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 23.8501,
    y: 1.85156,
    width: 28.2998,
    height: 33.5117
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_0_6764_129072_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 6,
    d: "M38 8C42.4183 8 46 11.5817 46 16C46 22.1716 42.2122 26.0271 39.4248 28.6523C38.6318 29.3992 37.3682 29.3992 36.5752 28.6523C33.7878 26.0271 30 22.1716 30 16C30 11.5817 33.5817 8 38 8Z",
    fill: "url(#paint3_linear_6764_129072)",
    stroke: "url(#paint4_linear_6764_129072)",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 29,
    y: 7,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_1_6764_129072_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6764_129072)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 16,
    r: 4,
    fill: "white",
    fillOpacity: 0.5,
    style: {
      fill: "white",
      fillOpacity: 0.5
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6764_129072_clip_path",
    transform: "translate(-23.8501 -1.85156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 8C42.4183 8 46 11.5817 46 16C46 22.1716 42.2122 26.0271 39.4248 28.6523C38.6318 29.3992 37.3682 29.3992 36.5752 28.6523C33.7878 26.0271 30 22.1716 30 16C30 11.5817 33.5817 8 38 8Z"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6764_129072",
    x: 29,
    y: 7,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129072",
    result: "shape"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_6764_129072_clip_path",
    transform: "translate(-29 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 16,
    r: 4
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6764_129072",
    x1: 22,
    y1: 19,
    x2: 27.826,
    y2: 44.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1859FF",
    style: {
      stopColor: "#1859FF",
      stopColor: "color(display-p3 0.0941 0.3490 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4BE9",
    style: {
      stopColor: "#0D4BE9",
      stopColor: "color(display-p3 0.0517 0.2944 0.9144)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6764_129072",
    x1: 38,
    y1: 20.0833,
    x2: 43.7995,
    y2: 39.8909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306AFE",
    style: {
      stopColor: "#306AFE",
      stopColor: "color(display-p3 0.1900 0.4165 0.9951)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1859FF",
    style: {
      stopColor: "#1859FF",
      stopColor: "color(display-p3 0.0941 0.3490 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6764_129072",
    x1: 32,
    y1: 19,
    x2: 34.9266,
    y2: 41.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5988FF",
    style: {
      stopColor: "#5988FF",
      stopColor: "color(display-p3 0.3504 0.5334 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336DFF",
    style: {
      stopColor: "#336DFF",
      stopColor: "color(display-p3 0.1994 0.4261 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6764_129072",
    x1: 33,
    y1: 8,
    x2: 42.5,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D5BB9",
    stopOpacity: 0.4,
    style: {
      stopColor: "#2D5BB9",
      stopColor: "color(display-p3 0.1753 0.3584 0.7245)",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5,
    style: {
      stopColor: "white",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6764_129072",
    x1: 31.5,
    y1: 8,
    x2: 45,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DFF",
    style: {
      stopColor: "#004DFF",
      stopColor: "color(display-p3 0.0010 0.3017 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDEFF",
    style: {
      stopColor: "#CFDEFF",
      stopColor: "color(display-p3 0.8134 0.8696 1.0000)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialAddress);
export default __webpack_public_path__ + "static/media/social_address.2b0d17571cd0efa25af21fe229d88a39.svg";
export { ForwardRef as ReactComponent };